<template>
    <div class="loading-wrapper">
        <div class="loading-bar-container">
            <div class="loading-bar"></div>
        </div>
    </div>
</template>
